import React from 'react'

export default function BuyNowTab() {
    return (
        <div>
            <h1>General</h1>
        </div>
    )
}
